(function () {
  function saveScrollState() {
    const productGrid = document.getElementById('search-grid') || document.getElementById('product-grid');
    if (!productGrid) return;

    sessionStorage.setItem('loadedPages', productGrid.querySelectorAll('li').length);
    sessionStorage.setItem('scrollPosition', window.scrollY);
  }

  function bindProductLinks() {
    document.querySelectorAll('.link-redirect-to-product').forEach((link) => {
      if (link.dataset.listenerAttached) return;
      link.dataset.listenerAttached = true;
      link.addEventListener('click', saveScrollState);
    });
  }

  function attachLoadMoreHandler() {
    const loadMoreBtn = document.getElementById('load-more');

    const productGrid = document.getElementById('search-grid') || document.getElementById('product-grid');
    if (!loadMoreBtn || !productGrid) return;

    // Prevent duplicate event listener
    if (loadMoreBtn.hasAttribute('data-handler-attached')) return;
    loadMoreBtn.setAttribute('data-handler-attached', 'true');

    loadMoreBtn.addEventListener('click', function () {
      loadMoreBtn.disabled = true;
      const nextUrl = loadMoreBtn.getAttribute('data-next-url');

      fetch(nextUrl)
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('#search-grid li').length
            ? doc.querySelectorAll('#search-grid li')
            : doc.querySelectorAll('#product-grid li');

          const productGridList = productGrid.querySelector('ul') || productGrid; // handle both collection and search cases

          newItems.forEach((item) => productGridList.appendChild(item));

          if (typeof initSwatches === 'function') {
            initSwatches(productGridList);
          }

          bindProductLinks();

          const nextBtn = doc.querySelector('#load-more[data-next-url]');
          if (nextBtn && nextBtn.getAttribute('data-next-url')) {
            loadMoreBtn.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
            loadMoreBtn.disabled = false;
          } else {
            loadMoreBtn.remove();
          }

          updateProgress();
        })
        .catch((err) => {
          console.error('[Load more failed]', err);
          loadMoreBtn.remove();
        });
    });
  }

  function updateProgress() {
    const productsShown =
      document.querySelectorAll('#search-grid li').length || document.querySelectorAll('#product-grid li').length;

    const totalEl = document.getElementById('products-total');
    const shownEl = document.getElementById('products-shown');
    const fillEl = document.getElementById('progress-fill');

    if (!totalEl || !shownEl || !fillEl) return;

    const productsTotal = parseInt(totalEl.textContent);
    shownEl.textContent = productsShown;

    const progress = Math.min((productsShown / productsTotal) * 100, 100);
    fillEl.style.width = `${progress}%`;
  }

  function restoreScrollAndProducts() {
    const loadedPages = parseInt(sessionStorage.getItem('loadedPages') || 0);
    const scrollPosition = parseInt(sessionStorage.getItem('scrollPosition') || 0);

    const navEntry = performance.getEntriesByType('navigation')[0];
    const isBackNavigation = navEntry && navEntry.type === 'back_forward';

    if (loadedPages > 0 && isBackNavigation) {
      (async () => {
        while (
          (document.querySelectorAll('#search-grid > *').length ||
            document.querySelectorAll('#product-grid > *').length) < loadedPages
        ) {
          const loadMoreBtn = document.getElementById('load-more');
          if (!loadMoreBtn) break;

          loadMoreBtn.click();
          await new Promise((resolve) => setTimeout(resolve, 400));
        }

        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      })();
    }

    sessionStorage.removeItem('loadedPages');
    sessionStorage.removeItem('scrollPosition');
  }

  document.addEventListener('DOMContentLoaded', () => {
    attachLoadMoreHandler();
    bindProductLinks();
    restoreScrollAndProducts();
  });

  document.addEventListener('facet-filter-updated', () => {
    requestAnimationFrame(() =>
      setTimeout(() => {
        attachLoadMoreHandler();
        bindProductLinks();
      }, 500)
    );
  });
})();
